var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccordionArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01222 7.44837L11.6836 2.7508C11.842 2.59107 11.9422 2.39755 11.9727 2.19269C12.0032 1.98783 11.9626 1.78005 11.8557 1.59346C11.7488 1.40687 11.58 1.24912 11.3688 1.13855C11.1576 1.02797 10.9127 0.969092 10.6626 0.96875H1.3199C1.0698 0.969092 0.824947 1.02797 0.61377 1.13855C0.402593 1.24912 0.233754 1.40687 0.126855 1.59346C0.0199557 1.78005 -0.0206183 1.98783 0.00984451 2.19269C0.0403073 2.39755 0.140557 2.59107 0.298954 2.7508L4.97033 7.44837C5.09436 7.57278 5.25023 7.67297 5.42675 7.74176C5.60327 7.81055 5.79606 7.84622 5.99127 7.84622C6.18648 7.84622 6.37927 7.81055 6.5558 7.74176C6.73232 7.67297 6.88819 7.57278 7.01222 7.44837Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionArrowDown);
export default __webpack_public_path__ + "static/media/AccordionArrowDown.25c35562.svg";
export { ForwardRef as ReactComponent };